import { z } from "zod";

import { getConfig } from "~/config";
import { Transaction } from "../types";
import { EmailSchema, validateTransactions } from "./validators";

const BASE_URL = getConfig("VITE_APP_API_URL");

/**
 * Submit transactions to the sandbox API
 * @param email Customer email address
 * @param transactions Array of transactions to submit
 * @returns Promise resolving to the API response
 * @throws Error if validation fails or API call fails
 */
export const submitTransactionsToApi = async (
  email: string,
  transactions: Transaction[]
): Promise<Response> => {
  try {
    const validatedEmail = EmailSchema.parse(email);
    const validatedTransactions = validateTransactions(transactions);
    const endpoint = `${BASE_URL}/api/e2e/users/${validatedEmail}/bank-transactions`;

    // Make the API call
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(validatedTransactions),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    return response;
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(
        `Validation error: ${error.errors.map((e) => e.message).join(", ")}`
      );
    }
    throw error;
  }
};
